<template>
  <b-card>
    <b-form v-on:submit.prevent @reset="resetFilter">
      <fieldset :disabled="loading">
        <b-form-group id="name-group" :label="$t('name')" label-for="name">
          <b-form-input size="sm" id="name" type="text" v-model="filter.name" v-on:keyup="onkeyup"/>
        </b-form-group>

        <b-form-group id="groupSource-group" :label="$t('source')" label-for="groupSource">
          <b-form-select size="sm" id="groupSource" :options="groupSources" v-model="filter.groupSource" v-on:change="updateGroups">
            <template slot="first">
              <option :value="null">{{ $t('all')}}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="groupType-group" :label="$t('type')" label-for="groupType">
          <b-form-select size="sm" id="groupType" :options="groupTypes" v-model="filter.groupType" v-on:change="updateGroups">
            <template slot="first">
              <option :value="null">{{ $t('all')}}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="ownerOrganizationNumber-group" :label="$t('organization')" label-for="organization">
          <b-form-input size="sm" id="ownerOrganizationNumber" type="text" v-model="filter.ownerOrganizationNumber" :disabled=isOrganizationAsActiveProfile(this.activeProfile) v-on:keyup="onkeyup"/>
        </b-form-group>

        <b-form-group id="memberUserId-group" :label="$t('member')" label-for="memberUserId">
          <b-form-input size="sm" id="memberUserId" type="text" v-model="filter.memberUserId" :disabled=isUserAsActiveProfile(this.activeProfile) v-on:keyup="onkeyup"/>
        </b-form-group>

        <b-form-group id="valid-group" :label="$t('valid')" label-for="valid">
          <b-form-checkbox size="lg" v-model="filter.isValid" name="checkbox" switch/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-form-select size="sm" id="perPage" v-model="paging.perPage" :options="paging.perPageAlternatives"/>
          </b-col>
          <b-col>
            <b-button size="sm" class="float-right" v-on:click="resetFilter">{{ $t('reset') }}</b-button>
          </b-col>
        </b-row>

        <b-form-group>
          <pagination v-bind:pagination="paging"/>
        </b-form-group>
      </fieldset>
    </b-form>
  </b-card>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'GroupFilter',
    extends: BaseComponent,

    computed: {
      ...mapGetters('groups', ['filter', 'paging', 'loading']),
      ...mapGetters('sessionStorage', ['isActiveProfileSet','activeProfile']),
      ...mapState('groups', { filter: state => state.filter}),
    },
    methods: {
      onkeyup (event) {
        if (event.which === 13) {
          this.updateGroups()
        }
      },
      updateGroups () {
        this.$store.dispatch('groups/getGroups')
      },
      resetFilter () {
        this.$store.dispatch('groups/resetFilter')
        this.updateGroups()
      }
    },
    watch: {
      'paging.perPage': function () {
        this.updateGroups()
      },
      'paging.currentPage': function () {
        this.updateGroups()
      },
      'filter.isValid': function () {
        this.updateGroups()
      },
      'isActiveProfileSet': function () {
        this.updateGroups()
      }
    }
  }
</script>